import React from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';

import { short } from '../../common/formatting/date';
import FullscreenToggle from '../components/FullscreenToggle';
import isEmpty from 'lodash.isempty';

const Procedures = ({ patientId, onExpand, onContract }) => {
	const [{ data, loading, error }] = useAxios(`/patients/${patientId}/procedures`);

	return (
		<div>
			<FullscreenToggle onExpand={onExpand} onContract={onContract} />
			<table className="table table-striped">
				<thead>
					<tr>
						<th>Procedure</th>
						<th>Procedure Date</th>
						<th>Source</th>
					</tr>
				</thead>
				<tbody>
					{loading && (
						<tr>
							<td colSpan={3}>Loading...</td>
						</tr>
					)}
					{(!loading && data && data.length === 0) && (
						<tr>
							<td colSpan={3}>No procedures found for this patient.</td>
						</tr>
					)}
					{!loading && data && data.map((procedure) => (
						<tr key={`${procedure.id}`}>
							<td>{procedure.name}</td>
							<td>{short(procedure.onset_dttm)}</td>
							<td>{(!isEmpty(procedure.data_source) && procedure.data_source !== 'patient') && procedure.data_source}</td>
						</tr>
					))}
					{!loading && error && (
						<tr>
							<td colSpan={3} className="text-danger">Problem loading Procedures</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};

Procedures.propTypes = {
	patientId: PropTypes.number.isRequired,
	onExpand: PropTypes.func.isRequired,
	onContract: PropTypes.func.isRequired,
	isDependentEvisit: PropTypes.bool,
	dependentAllergies: PropTypes.string
};

export default Procedures;
